import React, { useState, useEffect } from "react";
import { Table, Button, Pagination } from "react-bootstrap";
import AdminSidebar from "../../../components/admin/sidebar/adminSidebar";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../api/axios";
import "./adminEducationList.css"; // 스타일 추가

export default function AdminEducationsList() {
  const [educations, setEducations] = useState([]); // 게시물 데이터
  const [loading, setLoading] = useState(true); // 로딩 상태
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const itemsPerPage = 10; // 페이지당 항목 수
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // API 호출
        const response = await axiosInstance.get("/api/education/list"); // API 엔드포인트
        // 응답 데이터가 객체라면 educations 배열로 변환
        const educationsData = Array.isArray(response.data)
          ? response.data
          : response.data.data; // 데이터 배열 추출
        setEducations(educationsData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setEducations([]); // 오류 시 educations를 빈 배열로 설정
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 데이터 로드 함수
  const fetchEducations = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/api/education/list");
      const educationsData = Array.isArray(response.data)
        ? response.data
        : response.data.data;
      setEducations(educationsData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setEducations([]);
    } finally {
      setLoading(false);
    }
  };

  // 게시물 삭제 핸들러
  const handleDelete = async (educationId) => {
    if (!window.confirm("정말로 삭제하시겠습니까?")) return;

    try {
      await axiosInstance.delete(`/api/education/delete/${educationId}`); // 삭제 API 호출
      alert("게시물이 성공적으로 삭제되었습니다.");
      fetchEducations(); // 삭제 후 목록 갱신
    } catch (error) {
      console.error("Error deleting education:", error);
      alert("게시물 삭제 중 오류가 발생했습니다.");
    }
  };

  // 현재 페이지에 보여줄 데이터 계산
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEducations = educations.slice(indexOfFirstItem, indexOfLastItem);

  // 페이지 변경 핸들러
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // 날짜 포맷팅 함수 (KST 변환 및 보기 쉽게)
  const formatDate = (isoDate) => {
    const date = new Date(isoDate); // ISO 문자열을 Date 객체로 변환
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Asia/Seoul", // 대한민국 시간대
      hour12: false, // 24시간 형식
    };
    return new Intl.DateTimeFormat("ko-KR", options).format(date);
  };

  return (
    <AdminSidebar>
      <div className="admin-educations-page my-5">
        <h2 className="text-center mb-4">관광 전문가 양성 교육 관리</h2>

        {loading ? (
          <p className="text-center">로딩 중...</p>
        ) : (
          <>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>제목</th>
                  <th>작성자</th>
                  <th>작성일</th>
                  <th>작업</th>
                </tr>
              </thead>
              <tbody>
                {currentEducations.map((education, index) => (
                  <tr key={education.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{education.title}</td>
                    <td>{education.nameKor}</td>
                    <td>{formatDate(education.createdAt)}</td>{" "}
                    {/* 작성일 필드 */}
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        className="me-2"
                        onClick={() =>
                          navigate(`/admin/education/${education.educationId}`)
                        }
                      >
                        보기
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDelete(education.educationId)}
                      >
                        삭제
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* 페이지네이션 */}
            <Pagination className="justify-content-center mt-4">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {Array.from(
                { length: Math.ceil(educations.length / itemsPerPage) },
                (_, i) => (
                  <Pagination.Item
                    key={i + 1}
                    active={i + 1 === currentPage}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                )
              )}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={
                  currentPage === Math.ceil(educations.length / itemsPerPage)
                }
              />
              <Pagination.Last
                onClick={() =>
                  handlePageChange(Math.ceil(educations.length / itemsPerPage))
                }
                disabled={
                  currentPage === Math.ceil(educations.length / itemsPerPage)
                }
              />
            </Pagination>
          </>
        )}
      </div>
    </AdminSidebar>
  );
}
